import { limit, or, query, where } from 'firebase/firestore'
import type { Medicine } from '~/models'
import { ArrayService } from './serviceLive'

export class MedicineService extends ArrayService<Medicine> {
  constructor() {
    super('Medicines')
  }

  public listenForIdentifier(identifier: number): void {
    const listenQuery = query(
      this.collection,
      or(
        where('GPK', '==', identifier),
        where('HPK', '==', identifier),
        where('PRK', '==', identifier),
      ),
      limit(50),
    )
    this.listen(listenQuery)
  }

  public listenForName(name: string): void {
    const words = name.split(' ').map(word => word.toLowerCase())

    if (words[0] === '') {
      return
    }

    const listenQuery = query(
      this.collection,
      where('AllSearchTerms', 'array-contains', words[0]),
      limit(50),
    )
    this.listen(listenQuery)
  }
}
